export default __webpack_public_path__ + "static/media/veggiebites@2x.7bcac548.jpg";